// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__imV_5","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3IJiE"};